import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { mapIndustryList2 } from 'utils/config';
import { log } from 'utils';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartMarketNganhAnhHuong(props) {
  const DEFAULT_OPTION = {
    grid: { top: 10, right: 15, bottom: 120, left: 40 },
    color: ['#0FC786', '#F5465C'],
    tooltip: {
      // show: false,
      trigger: 'item',
      // formatter: '{b}: {c}',
      formatter: function (value, index) {
        // console.log(value);
        return `${value.name} <br/> Đóng góp vào Index (%): ${value.data.point} <br/>
        Đóng góp vào Index (điểm): ${value.value}`;
      },
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: 'category',
      data: [],
      // splitNumber: 1,
      splitLine: {
        show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
        alignWithLabel: false,
        length: 3,
      },
      axisLabel: {
        color: props.theme === 'light' ? '#000000' : '#ECECEC',
        fontSize: 8,
        borderColor: props.theme === 'light' ? '#000000' : '#ECECEC',
        rotate: 45,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'left',
      alignTicks: true,
      splitNumber: 4,
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'solid',
          color: '#2E2D3D',
          // dashOffset: 10,
          // opacity: 0.3,
        },
      },
      axisLabel: {
        color: props.theme === 'light' ? '#000000' : '#ECECEC',
        fontSize: 8,
        showMinLabel: true,
        showMaxLabel: true,
        // formatter: function (value, index) {
        //   return value + ' tỷ';
        // },
      },
    },
    series: [
      {
        type: 'bar',
        name: 'Top ngành ảnh hưởng',
        data: [],
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { topAnhHuong, t } = props;

  const preTopAnhHuong = usePrevious(topAnhHuong);

  useEffect(() => {
    if (topAnhHuong && !_.isEqual(topAnhHuong, preTopAnhHuong)) {
      _mapDataToState(topAnhHuong);
    }
  }, [topAnhHuong]);

  function _mapDataToState(res) {
    const newOption = _.cloneDeep(option);

    let objData = [],
      index = 0;

    if (res.contribPoint) {
      res.name.forEach((element) => {
        objData.push({
          name: t('algo.industry.' + element),
          value: res.contribPoint[index],
          point: res.value[index],
          itemStyle: {
            color: res.contribPoint[index] > 0 ? '#13BA7F' : '#F5465C',
          },
        });
        index++;
      });
    }

    const _sort = _.sortBy(objData, (o) => o.value).reverse();

    // log(_sort);

    newOption.xAxis.data = _.map(_sort, 'name');
    newOption.series[0].data = _sort;

    // console.// log(newOption);

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartMarketNganhAnhHuong);
